<template>
    <TransitionGroup name="slide-fade" tag="ul" class="au-dotted-list" appear>
        <slot></slot>
    </TransitionGroup>
</template>

<script setup lang="ts">

</script>

<style lang="scss">
.au-dotted-list {
    font-family: Montserrat;
    pointer-events: all;
    list-style-type: none;
    margin: 0;
    padding: 0;
    width: 100%;
    max-width: 100%;
}
</style>